import Vue from 'vue'

import currency from './currency'
import location from './location'

const loadFilters = () => {
  Vue.filter('currency', currency)
  Vue.filter('location', location)
}

export default loadFilters


// WEBPACK FOOTER //
// ./src/filters/index.js